import React from 'react';
import { ScreenVoteDecision } from '../../StudyList';
import { Button } from 'components/core';
import { AsyncVoteFunction } from 'hooks/study/useMakeVote';

type ScreenVoteButtonProps = {
  vote: ScreenVoteDecision;
  doVote: AsyncVoteFunction;
  isVoting: boolean;
};
const ScreenVoteButton = ({
  vote,
  doVote,
  isVoting,
}: ScreenVoteButtonProps) => {
  return (
    <Button
      disabled={isVoting}
      type="brand"
      size="md"
      onClick={() => doVote(vote, false)}
      data-pendo-key="vote-button"
    >
      {vote}
    </Button>
  );
};

export default ScreenVoteButton;
